import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function UpdateLock({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>UpdateLock</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7494 4.91006C10.9903 4.53409 9.15774 4.82531 7.58702 5.73315C6.01564 6.64137 4.80902 8.10776 4.19506 9.86777C3.58097 11.6281 3.60305 13.5589 4.25707 15.3036C4.91093 17.048 6.15045 18.4843 7.74177 19.3539C9.33244 20.2231 11.171 20.4697 12.9212 20.051C14.6719 19.6323 16.2229 18.5742 17.2858 17.0644C17.5242 16.7257 17.9921 16.6445 18.3308 16.8829C18.6695 17.1213 18.7508 17.5892 18.5123 17.9279C17.2437 19.73 15.3836 21.0043 13.2702 21.5099C11.1563 22.0156 8.93732 21.7165 7.02249 20.6702C5.10831 19.6242 3.62981 17.9038 2.85251 15.8301C2.07534 13.7569 2.04923 11.465 2.77876 9.37371C3.50841 7.28205 4.94699 5.52651 6.83641 4.43446C8.72649 3.34204 10.9379 2.98902 13.0629 3.44319C15.1875 3.89728 17.0765 5.1262 18.3862 6.89729C19.3326 8.17717 19.9314 9.67888 20.1396 11.2502L20.4614 10.9181C20.7496 10.6206 21.2244 10.6131 21.5219 10.9014C21.8194 11.1896 21.8269 11.6644 21.5386 11.9619L19.9944 13.5556C19.8531 13.7014 19.6588 13.7837 19.4557 13.7837C19.2527 13.7837 19.0584 13.7014 18.9171 13.5556L17.3729 11.9619C17.0846 11.6644 17.0921 11.1896 17.3896 10.9013C17.6871 10.6131 18.1619 10.6206 18.4501 10.9181L18.5926 11.0651C18.3771 9.88157 17.8966 8.75808 17.1801 7.78914C16.0834 6.30598 14.5089 5.28612 12.7494 4.91006Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.125 9.83082C9.125 8.79767 9.98695 8 11 8H11.75C12.7631 8 13.625 8.79767 13.625 9.83082V10.3223C14.2794 10.6018 14.75 11.2366 14.75 12V14.1692C14.75 15.2023 13.8881 16 12.875 16H9.875C8.86195 16 8 15.2023 8 14.1692V12C8 11.2366 8.47058 10.6018 9.125 10.3223V9.83082ZM10.625 10.1692H12.125V9.83082C12.125 9.66597 11.9796 9.49247 11.75 9.49247H11C10.7704 9.49247 10.625 9.66597 10.625 9.83082V10.1692ZM9.875 11.6616C9.64541 11.6616 9.5 11.8351 9.5 12V14.1692C9.5 14.334 9.64541 14.5075 9.875 14.5075H12.875C13.1046 14.5075 13.25 14.334 13.25 14.1692V12C13.25 11.8351 13.1046 11.6616 12.875 11.6616H9.875Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
